<template>
<div class="custom d-inline">
    <bee-label class="custom d-inline"
		:color="color"
		:bold="true" :content="formatedValue" :empty-state="emptyState"
    >
    </bee-label>
</div>
</template>
<script>
import currency from "currency.js";
export default {
name: "BeeMaterialAmountLabel",
props: ["value", "emptyState", "showZerosValues"],
computed: {
    localValue() {
        return this.value ? this.value : { quantity: null, unit_size_id: null }
    },
    color() {
        return this.localValue.quantity > 0 ? 'green' : 'red'
    },
    formatedValue(){ 
        if(this.localValue.quantity === 0 && this.showZerosValues)
            return currency(this.localValue.quantity, { separator: ",", decimal: ".", symbol: ""}).format()

        return this.localValue.quantity || this.emptyState
    }
}
};
</script>
<style>
.custom {
    caret-color: auto !important;
    font-family: Calibri !important;
    font-weight: 550 !important;
    font-size: 1.05rem !important;
}
</style>
